import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import SentimentAnalysis from '@/plugins/graphql/queries/v3/sentiment-analysis.gql';
import sentimentAnalysis from '@/plugins/graphql/subscriptions/v3/sentiment-analysis.gql';
let SentimentAnalysisSummary = class SentimentAnalysisSummary extends Vue {
    constructor() {
        super(...arguments);
        this.sentimentData = {
            total_interactions: 0,
            positive_count: 0,
            neutral_count: 0,
            negative_count: 0,
        };
    }
    get total_interactions() {
        return this.sentimentData.total_interactions;
    }
    get positive_percentage() {
        return (Math.round((this.sentimentData.positive_count / this.sentimentData.total_interactions) * 100) || 0);
    }
    get neutral_percentage() {
        return (Math.round((this.sentimentData.neutral_count / this.sentimentData.total_interactions) * 100) || 0);
    }
    get negative_percentage() {
        return (Math.round((this.sentimentData.negative_count / this.sentimentData.total_interactions) * 100) || 0);
    }
    get pointer_rotation() {
        // Handle edge cases
        if (this.negative_percentage === 100)
            return -90;
        if (this.neutral_percentage === 100)
            return 0;
        if (this.positive_percentage === 100)
            return 90;
        // Calculate weighted position
        return (((this.negative_percentage * -90) +
            (this.neutral_percentage * 0) +
            (this.positive_percentage * 90)) / 100);
    }
};
SentimentAnalysisSummary = __decorate([
    Component({
        apollo: {
            sentimentData: {
                query: SentimentAnalysis,
                variables() {
                    return {
                        appUuid: this.$route.params.appUUID,
                        period: this.period,
                    };
                },
                update(data) {
                    return data.fetchAppByUuid.sentimentSummary;
                },
                skip() {
                    return !this.$route.params.appUUID;
                },
                subscribeToMore: {
                    document: sentimentAnalysis,
                    variables() {
                        return {
                            appGlobalId: this?.$store?.state?.appGlobalId,
                            period: this.period,
                        };
                    },
                    updateQuery: (prev, { subscriptionData: { data: { sentimentSummary: { app: { sentimentSummary }, }, }, }, }) => {
                        if (sentimentSummary) {
                            return {
                                fetchAppByUuid: {
                                    ...prev.fetchAppByUuid,
                                    sentimentSummary,
                                },
                            };
                        }
                        return prev;
                    },
                },
                fetchPolicy: 'network-only',
            },
        },
        data() {
            return {
                period: 'daily',
                periodOptions: [
                    { text: 'Daily', value: 'daily' },
                    { text: 'Weekly', value: 'weekly' },
                    { text: 'Monthly', value: 'monthly' },
                ],
            };
        },
    })
], SentimentAnalysisSummary);
export default SentimentAnalysisSummary;
